import { Button, Notice, formatDate } from "@omnabase/ui";
import { SPAM_RETENTION_DAYS } from "@omnabase/shared";
import { ApiError } from "../../lib/api";
import { useWs } from "../../lib/nav";
import { deleteTicket, mayDeleteTicket, restoreTicket } from "../../lib/deleted";
import { useSession } from "../../shell/store";

/** A deleted conversation opened from the Deleted view (the one-card round, 2026-10-23): when it went, when it goes for good, and Restore. */
export function DeletedNotice({ deletedAt, onRestore }: { deletedAt: string; onRestore: () => void }) {
  const goes = new Date(Date.parse(deletedAt) + SPAM_RETENTION_DAYS * 86_400_000).toISOString();
  return <Notice strip icon="trash" action={<Button size="sm" icon="history" onClick={onRestore}>Restore</Button>}>Deleted on {formatDate(deletedAt)}; it goes for good on {formatDate(goes)}.</Notice>;
}

/** The ticket page's Delete and Restore: who is offered Delete, the call with its toast (Undo restores), and Restore. */
export function useTicketDeletion(number: number, o: { onDone: () => void; onRestored: () => void }) {
  const { slug } = useWs(); const { workspace, me, toast } = useSession();
  const failed = (e: unknown, what: string) => toast(e instanceof ApiError ? e.message : what, { kind: "error" });
  const restore = async () => {
    try { await restoreTicket(slug, number); toast(`#${number} restored`, { kind: "success" }); o.onRestored(); } catch (e) { failed(e, "Could not restore it"); }
  };
  const remove = async () => {
    try { await deleteTicket(slug, number); } catch (e) { failed(e, "Could not delete it"); return; }
    toast(`#${number} deleted · restorable for ${SPAM_RETENTION_DAYS} days`, { kind: "success", action: { label: "Undo", onClick: () => void restoreTicket(slug, number).then(o.onRestored, (e) => failed(e, "Could not restore it")) } });
    o.onDone();
  };
  const offered = (t: { assigneeId: string | null; projectId: string; deletedAt?: string | null; sample?: boolean }) => !t.deletedAt && !t.sample && mayDeleteTicket(workspace, t, me.user.id);
  return { remove, restore, offered };
}
